import { IconButton, Stack, Typography } from '@mui/material';
import React from 'react';
import ReportProblemIcon from '@mui/icons-material/ReportProblem';
import { useTranslation } from 'react-i18next';

export default function PlanLimit() {
  const { t } = useTranslation();
  return (
    <Stack
      style={{ backgroundColor: '#CF1010' }}
      alignItems={'center'}
      justifyContent={'center'}
      direction={'row'}
    >
      <IconButton>
        <ReportProblemIcon
          style={{ transform: 'scale(1.143)', width: '16px', height: '13px', color: '#FFFFFF' }}
          color="#FFFFFF"
        />
      </IconButton>
      <Typography
        className="ff-Roboto fw-regular fs-12"
        color={'#FFFFFF'}
      >
        {t('You have reached your plan limit')}
      </Typography>
    </Stack>
  );
}
